@if (displayDepartments) {
  <div>
    <div class="grid-x grid-margin-x flex-align-bottom">
      <div class="cell small-10">
        <label for="newDepartment">Add New Department</label>
        <input type="text" name="newDepartment" [(ngModel)]="departmentName">
      </div>
      <div class="cell small-2">
        <button class="button" [disabled]="!departmentName.length" (click)="addDepartment()">Add</button>
      </div>
    </div>
    <ag-grid-angular class="data-grid  margin-top" [gridOptions]="gridOptions" aria-label="Organization Departments"></ag-grid-angular>
  </div>
}
<confirm-dialog [showDialog]="dialogService.showDialog" [dialogType]="dialogService.dialogType" [message]="dialogService.message" (onDialogConfirm)="onDialogConfirm()" (onDialogClose)="onDialogClose()"></confirm-dialog>
